export const FontSize = {
  s3: '9px',
  s2: '10px',
  s1: '11px',
  base: '12px',
  l1: '14px',
  l2: '16px',
  l3: '18px',
  l4: '20px',
  l5: '22px',
  l6: '24px',
};
